import request from '../request'

let link = process.env.NODE_ENV == 'development' ? '/host' : process.env.API
// 职位详情
// export const recruitInfos = (params) => {
// 	// console.log('api-----/v1/recruit_infos/show');
// 	return request({
// 		url: '/v1/recruit_infos/show',
// 		method: 'get',
// 		params,
// 	})
// }
// 职位详情收藏，取消收藏
// export const recruitLike = (params) => {
// 	return request({
// 		url: '/v1/recruit_infos/switch_like',
// 		method: 'post',
// 		data: params,
// 	})
// }
// // 实习僧投递
// export const deliverToShixiseng = (params) => {
// 	return request({
// 		url: '/v1/recruit_infos/deliver_to_shixiseng',
// 		method: 'post',
// 		data: params,
// 	})
// }
//
// // 多面
// export const deliverToDuomian = data => {
// 	return request({
// 		url: '/v1/recruit_infos/deliver_to_duomian',
// 		method: 'post',
// 		data
// 	})
// }

// export const getCities = params => {
// 	return request({
// 		url: '/v1/cities/all',
// 		method: 'get',
// 		params
// 	})
// }
//
// // /api/v1/jobs/cv_sync_hr_jobs
// // 职位搜索页面
// export const getJobsListSearch = params => {
// 	return request({
// 		url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v1/jobs/cv_sync_hr_jobs',
// 		method: 'get',
// 		params
// 	})
// }
// https://api.wondercv.cn/hr/v3/jobs/company_list_unlogin
// 搜索简历
export const querySearchResume = (data) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT)  + `/v3/jobs/company_list_unlogin`,
		method: 'post',
		data
	})
}

// query解析
export const querySearch = (data) => {
	return request({
		url: link + `/ml/v2/parser/queries/jobs`,
		method: 'post',
		data
	})
}

// 未登录职位
export const companyListUnlogin = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + `/v2/jobs/company_list_unlogin`,
		method: 'get',
		params
	})
}

// banner
export const getBanner = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.API) + `/cv/v3/banners`,
		method: 'get',
		params
	})
}
export const getV4Banner = (params) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.API) + `/cv/v4/banners`,
		method: 'get',
		params
	})
}

export const getVideo = (params)  => {
	return request({
		url: `/v3/video_pages`,
		method: 'get',
		params
	})
}

// 获取直播列表
export const getLiveList = () => {
  return request({
    url: `/v3/lives`,
    method: 'get'
  })
}
export let addNps = (data) => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.ADMIN) + `/admin/v1/nps`,
		method: 'post',
		data: data
	})
}

// export const getDownloadCv = params => {
// 	return request({
// 		url: '/v1/get_download_cv',
// 		method: 'get',
// 		params
// 	})
// }

// 获取关注公司列表
export const getFollowCompanyList= params => {
	return request({
		url: '/v4/favorite_companies',
		method: 'get',
		params
	})
}

// 获取收藏职位列表
export const getFavoriteList = params => {
	return request({
		url: '/v3/jobs/favorite_jobs',
		method: 'get',
		params
	})
}
// 获取已投职位列表
export const getApplicationList = params => {
	return request({
		url: '/v3/jobs/application_jobs',
		method: 'get',
		params
	})
}
// 获取网申状态
export const getNetApplication = params => {
	return request({
		url: '/v3/jobs/net_application_status',
		method: 'get',
		params
	})
}
// 修改网申状态
export const changeNetApplication = data => {
	return request({
		url: '/v3/jobs/net_application_status',
		method: 'put',
		data
	})
}
// 校招网申
export const getJobsList = params => {
	return request({
		url: '/v3/comp_recruit_infos/index',
		method: 'get',
		params
	})
}
// 切换喜欢状态
export const changeLike = data => {
	return request({
		url: '/v3/comp_recruit_infos/like',
		method: 'post',
		data
	})
}
// 校招详情
export const getInfo = (token) => {
	return request({
			url: `/v3/comp_recruit_infos/${token}`,
			method: 'get'
	})
}

// 超级简历自己的工作
export const getOurCompanyJobs = () => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + `/v2/jobs/our_company_jobs`,
		method: 'get'
	})
}

// 基于在线简历内的求职信息或求职意向推荐职位
export const getIntentionToJob = params => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + `/v1/jobs/intention_to_job`,
		method: 'get',
		params
	})
}

export const getBriefReport = (params) => {
	return request({
		url: `/v3/jobscan_reports/brief_report`,
		method: 'get',
		params
	})
}

// 获取职位详情
export const getProfessionDetail = (data,url) => {
	return request({
		url: `/v3/spring_recruits/${data}`,
		method: 'post',
		data: url
	})
}
// 下载阻断获取职位详情
export const getTempJobs = params => {
	return request({
		url: `/v3/jobs/temp_jobs`,
		method: 'get',
		params
	})
}

//检查简历完整度
export const checkResume = token => {
	return request({
		url: `/v3/jobscan_reports/check?cv_token=${token}`,
		method: 'get'
	})
}

//获取内推列表
export const get_recruit_list = params => {
	return request({
		url: `/v4/comp_recruit_infos`,
		method: 'get',
		params
	})
}
//关注/取关校招职位
export const updateLikeRecruit = (token, data) => {
	return request({
			url: `/v4/comp_recruit_infos/${token}/like`,
			method: 'PUT',
			data
	})
}
//热门校招职位
export const getRecruitHotJobs = () => {
	return request({
			url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + `/v1/comp_recruit_infos/hot_jobs`,
			method: 'GET',
	})
}

//职位聚合页获取公司下职位的信息
export const getCompanyJobs= (data) => {
	return request({
			url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + `/v3/aggregation/jobs/search`,
			method: 'POST',
      data
	})
}
//获取校招小程序裂变页面二维码
export const getSchoolJobsCode= () => {
	return request({
		url: `/v3/jobs/miniprogram_qrcodes`,
		method: 'GET'
	})
}
// 阿里云职位投递
export const aliyunDelivery = (job_token, data) => {
	return request({
		url: `/v3/jobs/${job_token}/aliyun/delivery`,
		method: 'POST',
		data
	})
}
